// eslint-disable-next-line @typescript-eslint/no-explicit-any
let wasmModule: any = null;
let initPromise: Promise<void> | null = null;

export const initCrypto = (): Promise<void> => {
  // eslint-disable-next-line @typescript-eslint/prefer-nullish-coalescing
  if (!initPromise) {
    initPromise = (async () => {
      try {
        wasmModule = await import('../pkg-web/crypto_wasm.js');
        // eslint-disable-next-line @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
        await wasmModule.default();
      } catch (error) {
        initPromise = null;
        // eslint-disable-next-line no-console
        console.error('Failed to load WASM module:', error);
        throw error;
      }
    })();
  }
  return initPromise;
};

export const decrypt = async (data: Uint8Array, key: string): Promise<string> => {
  await initCrypto();
  // eslint-disable-next-line @typescript-eslint/no-unsafe-return, @typescript-eslint/no-unsafe-call, @typescript-eslint/no-unsafe-member-access
  return wasmModule.decrypt(data, key);
};
